import React, { useState, useEffect, useContext, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import { AuthContext } from '../context/AuthContext';
import api from '../services/axios';
import alertService from '../services/alerts';
import '../styles/EditarPerfilPage.css';
import defaultPhoto from '../assets/fotoPerfil.jpg';

function EditarPerfilPage() {
  const { user, updateUserProfile  } = useContext(AuthContext);
  const navigate = useNavigate();

   
   
  const [formData, setFormData] = useState({
    nombre: '',
    apellido_paterno: '',
    apellido_materno: '',
    correo: ''
  });

  const [formErrors, setFormErrors] = useState({});
  const [photo, setPhoto] = useState(defaultPhoto);
  const [newImage, setNewImage] = useState(null);
  const initialDataRef = useRef(null);
  const initialPhotoRef = useRef(null);
  const [isDirty, setIsDirty] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

  useEffect(() => {
    if (user) {
       
      const initial = {
        nombre: user.nombre || '',
        apellido_paterno: user.apellido_paterno || '',
        apellido_materno: user.apellido_materno || '',
        correo: user.correo || ''
      };
      setFormData(initial);

      fetchPhoto(user.id_usuario).then((photoURL) => {
         
        initialPhotoRef.current = photoURL || defaultPhoto;
        setPhoto(photoURL || defaultPhoto);

         
        initialDataRef.current = {
          ...initial,
          photo: photoURL || defaultPhoto
        };
      });
    }
  }, [user]);

  const fetchPhoto = async (id_usuario) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/usuarios/${id_usuario}/foto`);
      if (!response.ok) {
        return null;
      }
      const photoBlob = await response.blob();
      if (photoBlob.size === 0) {
        return null;
      }
      const contentType = response.headers.get('Content-Type');
      if (!contentType || !contentType.includes('image')) {
        return null;
      }
      const photoURL = URL.createObjectURL(photoBlob);
      return photoURL;
    } catch (error) {
      return null;
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));

     
    checkIfDirty(name, value, null);
  };

   

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.type !== 'image/jpeg') {
        alertService.error('Formato No Válido', 'Solo se permiten imágenes en formato JPG.');
        return; 
      }
      setNewImage(file);
      const previewURL = URL.createObjectURL(file);
      setPhoto(previewURL);
  
      checkIfDirty(null, null, previewURL);
    }
  };
  
  const checkIfDirty = (fieldName, fieldValue, newPhotoURL) => {
    if (!initialDataRef.current) return;  

    const currentInitial = { ...initialDataRef.current };
    let changed = false;

    if (fieldName) {
       
      if (fieldValue !== currentInitial[fieldName]) {
        changed = true;
      }
    }
    if (newPhotoURL !== null) {
       
      if (newPhotoURL !== currentInitial.photo) {
        changed = true;
      }
    }

    if (!changed) {
      const sameNombre = formData.nombre === currentInitial.nombre;
      const sameAP = formData.apellido_paterno === currentInitial.apellido_paterno;
      const sameAM = formData.apellido_materno === currentInitial.apellido_materno;
      const samePhoto = photo === currentInitial.photo;
      changed = !(sameNombre && sameAP && sameAM && samePhoto);
    }

    setIsDirty(changed);
  };

  const validateForm = () => {
    const errors = {};
     
    const onlyLettersRegex = /^[A-Za-zÀ-ÿ\s]+$/;
  
    if (!formData.nombre.trim()) {
      errors.nombre = 'El nombre es requerido';
    } else if (!onlyLettersRegex.test(formData.nombre.trim())) {
      errors.nombre = 'El nombre solo debe contener letras';
    }
  
    if (!formData.apellido_paterno.trim()) {
      errors.apellido_paterno = 'El apellido paterno es requerido';
    } else if (!onlyLettersRegex.test(formData.apellido_paterno.trim())) {
      errors.apellido_paterno = 'El apellido paterno solo debe contener letras';
    }
  
    if (!formData.apellido_materno.trim()) {
      errors.apellido_materno = 'El apellido materno es requerido';
    } else if (!onlyLettersRegex.test(formData.apellido_materno.trim())) {
      errors.apellido_materno = 'El apellido materno solo debe contener letras';
    }
  
    return errors;
  };

  const handleBackButtonClick = async () => {
    if (isDirty) {
      const confirmed = await alertService.confirm(
        "Cambios Sin Guardar",
        "Hay cambios sin guardar. ¿Seguro que deseas cancelar?",
        {
          confirmButtonText: 'Sí, Cancelar',
          cancelButtonText: 'Continuar Editando'
        }
      );
      if (!confirmed.isConfirmed) {
        return;  
      }
    }
    navigate('/dashboard');
  };
  

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!user) return;
  
    const errors = validateForm();
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }
    setFormErrors({});
  
    const confirmed = await alertService.confirm(
      "Guardar Cambios",
      "¿Deseas guardar los cambios?",
      {
        confirmButtonText: 'Guardar',
        cancelButtonText: 'Cancelar'
      }
    );
    if (!confirmed.isConfirmed) {
      return;  
    }
  
    try {
      const formDataToSend = new FormData();
      formDataToSend.append('nombre', formData.nombre);
      formDataToSend.append('apellido_paterno', formData.apellido_paterno);
      formDataToSend.append('apellido_materno', formData.apellido_materno);
  
      if (newImage) {
        formDataToSend.append('imagen', newImage);
      }
  
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/usuarios/editar-perfil/${user.id_usuario}`, {
        method: 'PUT',
        body: formDataToSend
      });
  
      if (response.ok) {
       
        const updatedUserResponse = await fetch(`${process.env.REACT_APP_API_URL}/api/usuarios/${user.id_usuario}`, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
          }
        });
  
        if (updatedUserResponse.ok) {
          const updatedUserData = await updatedUserResponse.json();
  
          
          updateUserProfile(updatedUserData);
  
          
          navigate('/dashboard');
        } else {
          console.error("Error al obtener los datos actualizados del usuario");
        }
      } else {
        console.error("Error al guardar el perfil");
      }
    } catch (error) {
      console.error('Error al guardar el perfil:', error);
    }
  };
  
  
  
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (isDirty) {
        e.returnValue = "Tienes cambios sin guardar. ¿Seguro que deseas salir?";
      }
    };
    const handleHistoryPopState = async (event) => {
      if (isDirty) {
        const message = "Tienes cambios sin guardar. ¿Seguro que deseas salir?";
        const confirmed = await alertService.confirm(
          "Cambios Sin Guardar",
          message,
          {
            confirmButtonText: 'Sí, Salir',
            cancelButtonText: 'Continuar Editando'
          }
        );
        if (confirmed.isConfirmed) {
          navigate('/dashboard');
        } else {
          event.preventDefault(); 
        }
      } else {
        navigate('/dashboard'); 
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("popstate", handleHistoryPopState);
    window.history.pushState(null, null, window.location.href);   
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("popstate", handleHistoryPopState);
    };
  }, [isDirty, navigate]);
  
 

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 1025;
      setIsMobile(mobile);
      if (!mobile) {
        setSidebarOpen(true);
      } else {
        setSidebarOpen(false);
      }
    };
    window.addEventListener('resize', handleResize);
    if (window.innerWidth >= 1025) {
      setSidebarOpen(true);
    }
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(prev => !prev);
  };

  const handleCloseSidebar = () => {
    if (isMobile && sidebarOpen) {
      setSidebarOpen(false);
    }
  };

  return (
    <div className="dashboard-container">
      {(!isMobile || (isMobile && sidebarOpen)) && (
        <Sidebar
          onLogoClick={() => {
            if (isMobile) setSidebarOpen(false);
          }}
          onLinkClick={handleCloseSidebar}
        />
      )}

      <div className="main-content" onClick={handleCloseSidebar}>
        <div className="dashboard-title-card">
          {isMobile && (
            <button 
              className="menu-toggle"
              onClick={toggleSidebar}
              aria-label="Abrir menú"
            >
              <i className="fas fa-bars"></i>
            </button>
          )}
          <div className="dashboard-title-section">
            <h1 className="dashboard-title">
              Editar Perfil
            </h1>
            <span className="dashboard-title-sub">
              Actualiza tu información personal
            </span>
          </div>
        </div>

        <div className="futuristic-form-container">
          <div className="form-header">
            <h2 className="form-title">
              <i className="fas fa-user-edit"></i>
              Información Personal
            </h2>
            <button className="back-button" onClick={handleBackButtonClick}>
              <i className="fas fa-arrow-left"></i>
              Regresar
            </button>
          </div>

          <div className="profile-layout">
            <div className="profile-left">
              <div className="image-wrapper">
                {photo ? (
                  <img src={photo} alt="Foto de perfil" className="profile-photo" />
                ) : (
                  <div className="no-photo">Sin foto</div>
                )}
                <label className="btn-change-photo">
                  <i className="fas fa-camera"></i>
                  Cambiar foto
                  <input
                    type="file"
                    accept="image/*"
                    style={{ display: 'none' }}
                    onChange={handleFileChange}
                  />
                </label>
              </div>
            </div>
            
            <div className="profile-right">
              <form onSubmit={handleSubmit} className="editar-perfil-form">
                <div className="form-group">
                  <label>Nombre</label>
                  <input
                    type="text"
                    name="nombre"
                    value={formData.nombre}
                    onChange={handleChange}
                    maxLength="40"
                    placeholder="Ingresa tu nombre"
                    className={`form-input ${formErrors.nombre ? 'error' : ''}`}
                  />
                  {formErrors.nombre && (
                    <span className="error-message">
                      <i className="fas fa-exclamation-circle"></i>
                      {formErrors.nombre}
                    </span>
                  )}
                </div>
                
                <div className="form-group">
                  <label>Apellido Paterno</label>
                  <input
                    type="text"
                    name="apellido_paterno"
                    value={formData.apellido_paterno}
                    onChange={handleChange}
                    maxLength="40"
                    placeholder="Ingresa tu apellido paterno"
                    className={`form-input ${formErrors.apellido_paterno ? 'error' : ''}`}
                  />
                  {formErrors.apellido_paterno && (
                    <span className="error-message">
                      <i className="fas fa-exclamation-circle"></i>
                      {formErrors.apellido_paterno}
                    </span>
                  )}
                </div>
                
                <div className="form-group">
                  <label>Apellido Materno</label>
                  <input
                    type="text"
                    name="apellido_materno"
                    value={formData.apellido_materno}
                    onChange={handleChange}
                    maxLength="40"
                    placeholder="Ingresa tu apellido materno"
                    className={`form-input ${formErrors.apellido_materno ? 'error' : ''}`}
                  />
                  {formErrors.apellido_materno && (
                    <span className="error-message">
                      <i className="fas fa-exclamation-circle"></i>
                      {formErrors.apellido_materno}
                    </span>
                  )}
                </div>
                
                <div className="form-group">
                  <label>Correo Electrónico</label>
                  <input
                    type="email"
                    name="correo"
                    value={formData.correo}
                    disabled
                    className="form-input disabled"
                    placeholder="Tu correo electrónico"
                  />
                  <span className="field-note">
                    <i className="fas fa-info-circle"></i>
                    El correo no se puede modificar
                  </span>
                </div>
                
                <div className="submit-button-container">
                  <button 
                    type="submit" 
                    className="submit-button"
                    disabled={!isDirty}
                  >
                    <i className="fas fa-save"></i>
                    Guardar Cambios
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {isMobile && sidebarOpen && (
        <div className="overlay" onClick={handleCloseSidebar}></div>
      )}
    </div>
  );
}

export default EditarPerfilPage;

